import { format } from 'date-fns';
import { normalizeDate } from 'lib';

import {
    CommentTagged, ConnectInFive, ConnectRequest,
    ConnectStatus, ModerationNotice, PostComment, PostMention, PostReaction, PostTagged, Shoutout,
    ShoutoutReaction, UserFollow
} from './';

const Notification = ({ item, section }) => {
  function getTimestamp() {
    switch (true) {
      case ['common.today', 'common.yesterday'].includes(section.title):
        return format(new Date(item.updatedAt), 'h:mm a');

      case ['common.earlier'].includes(section.title):
        return normalizeDate(new Date(item.updatedAt), 'Days');

      default:
    }
  }

  const data = { ...item, timestamp: getTimestamp() };

  switch (item.type) {
    case 'postReaction':
      return <PostReaction data={data} />;
    case 'shoutoutReaction':
      return <ShoutoutReaction data={data} />;
    case 'userSubscribe':
    case 'userFollow':
      return <UserFollow data={data} />;
    case 'postComment':
      return <PostComment data={data} />;
    case 'postTagged':
      return <PostTagged data={data} />;
    case 'postMention':
      return <PostMention data={data} />;
    case 'commentTagged':
      return <CommentTagged data={data} />;
    case 'shoutout':
      return <Shoutout data={data} />;
    case 'connectRequest':
      return <ConnectRequest data={data} />;
    case 'connectInFive':
      return <ConnectInFive data={data} />;
    case 'connectConfirm':
    case 'connectPending':
    case 'connectCancel':
    case 'connectRefuse':
    case 'connectStart':
      return <ConnectStatus data={data} />;
    case 'contentRemoved':
    case 'moderationWarning':
      return <ModerationNotice data={data} />;
    default:
      return null;
  }
};

export default Notification;
